import axios from '@/libs/http'
import {appendIfNotEmpty} from "@/libs/util";

/**
 * 修改店员在线状态
 */
export const updateStatus = (clerkId, status)=>{
    return axios.request({
        url: '/s/clerk/updateStatus',
        params: {
            clerkId,
            status
        },
        method: 'post'
    })
}

/**
 * 修改店员上架状态
 */
export const updateIsDisabled = (clerkId, isDisabled)=>{
    return axios.request({
        url: '/s/clerk/updateIsDisabled',
        params: {
            clerkId,
            isDisabled
        },
        method: 'post'
    })
}

/**
 * 修改店员推荐状态
 */
export const updateIsRecommend = (clerkId, isRecommend)=>{
    return axios.request({
        url: '/s/clerk/updateIsRecommend',
        params: {
            clerkId,
            isRecommend
        },
        method: 'post'
    })
}

/**
 * 修改店员显示状态
 */
export const updateIsHide = (clerkId, isHide)=>{
    return axios.request({
        url: '/s/clerk/updateIsHide',
        params: {
            clerkId,
            isHide
        },
        method: 'post'
    })
}

/**
 * 修改店员置顶状态
 */
export const updateIsTop = (clerkId, isTop)=>{
    return axios.request({
        url: '/s/clerk/updateIsTop',
        params: {
            clerkId,
            isTop
        },
        method: 'post'
    })
}

/**
 * 修改店员随机单开关
 */
export const updateRandomOrderSwitch = (clerkId, randomOrderSwitch)=>{
    return axios.request({
        url: '/s/clerk/updateRandomOrderSwitch',
        params: {
            clerkId,
            randomOrderSwitch
        },
        method: 'post'
    })
}

/**
 * 修改是否需要实名
 */
export const updateRequireVerify = (clerkId, requireVerify)=>{
    return axios.request({
        url: '/s/clerk/updateRequireVerify',
        params: {
            clerkId,
            requireVerify
        },
        method: 'post'
    })
}
/**
 * 修改店员等级
 */
export const updateGrade = (clerkId,grade)=>{
    return axios.request({
        url: '/s/clerk/updateGrade',
        params:{
            clerkId,
            grade,
        },
        method: 'post'
    })
}

/**
 * 修改店员是否固定等级
 */
export const updateIsFixGrade = (clerkId,isFixGrade)=>{
    return axios.request({
        url: '/s/clerk/updateIsFixGrade',
        params:{
            clerkId,
            isFixGrade,
        },
        method: 'post'
    })
}

/**
 * 修改店员分组
 */
export const updateGroup = (clerkId,groupId)=>{
    return axios.request({
        url: '/s/clerk/updateGroup',
        params:{
            clerkId,
            groupId,
        },
        method: 'post'
    })
}
/**
 * 获取店员链接
 */
export const shareInterface = (clerkId) => {
    return axios.request({
        url: '/s/clerk/getQrCode',
        params: {
            clerkId
        },
        method: 'get'
    })
}
/**
 * 修改店员备注
 */
export const updateClerkRemark = (id, remark) => {
    var data = new URLSearchParams();
    data.append("id", id);
    data.append("remark", remark)
    return axios.request({
        url: '/s/clerk/updateClerkRemark',
        data,
        method: 'post'
    })
}
/**
 * 发起离职
 * @param clerkId
 * @param type
 * @param cause
 * @returns {*}
 */
export const addClerkResign = (clerkId,type,cause) => {
    let data = new URLSearchParams()
    data.append("clerkId", clerkId)
    data.append("type", type)
    data.append("cause", cause)
    return axios.request({
        url: '/s/clerk/addClerkResign',
        data,
        method: 'post'
    })
}
